<template>
  <v-dialog v-model="value" @keydown.esc="close()" max-width="1200px">
    <material-card color="success" :title="title">

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="download()">Download</v-btn>
        <v-btn class="mx-1 font-weight-light" color="primary" @click="close()">Cancel</v-btn>
      </v-flex>

      <v-form ref="form">
        <v-container grid-list-md>
          <v-layout wrap>

            <v-flex md12>
              <section class="scroll" ref="scroller">
                <vue-pdf-embed :source="pdf" />
              </section>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

    </material-card>
  </v-dialog>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

import { downloadPdf as pdf_sae } from "@/api/adverse_event";
import { downloadPdf as pdf_spm } from "@/api/spm";
import { downloadPdf as pdf_pregnancy } from "@/api/pregnancy";
import { downloadPdf as pdf_treatment } from "@/api/treatment";

export default {
  components: {
    VuePdfEmbed
  },
  inheritAttrs: false,
  props: {
    value: Boolean,
    item: Object,
    itemType: String
  },
  data() {
    return {
      numPages: undefined,
      pdf: "",
      map: {
        'sae': pdf_sae,
        'spm': pdf_spm,
        'pregnancy': pdf_pregnancy,
        'treatment': pdf_treatment,
      }
    };
  },
  mounted() { },
  watch: {
    value(val) {
      if (val) {
        this.map[this.itemType](this.item.id, this.itemType, this.item.pdf, false).then((ret) => {
          // this.pdf = pdf.createLoadingTask(ret);
          // this.pdf.promise.then(pdf => {
          //   this.numPages = pdf.numPages;
          //   this.$refs.scroller.scrollTop = 0
          // });
          this.pdf = ret
        })
      }
    },
  },
  computed: {
    title() {
      return "Pdf Preview";
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    download() {
      this.map[this.itemType](this.item.id, this.itemType, this.item.pdf, true);
    },
  },
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.scroll {
  overflow-y: scroll;
  /* it works! */
  height: 600px;
  border: 1px solid black;
}
</style>
